import { useValue } from '@morningtrain/react-resources'

export { default as Integer } from './Integer'
export { default as Percentage } from './Percentage'
export * from './simpletons'
export * from '@morningtrain/react-columns'
export { default as Duration } from './Duration'
export { default as Count } from './Count'
export { default as DownloadFile } from './DownloadFile'
export { default as Aggregate } from './Aggregate'
export { default as Avatar } from './Avatar'
export { default as CompactNumber } from './CompactNumber'
export { default as WageRatio } from './WageRatio'
export { default as HumanizedDuration } from './HumanizedDuration'

export function Debug (props) {
  const name = props.name
  const defaultValue = props.defaultValue
  const value = useValue(name, defaultValue)
  console.log(value)
  return null
}
